/**
 * Implements a Trending line in header
 * Data located in useTrending.ts
 */
import TrendingCoinMobile, { GainersPairMobile } from './TrendingCoin';
import flash from '../../../assets/images/flash.svg';
import Image from '../../../atoms/Image';
import { useMarqueeItems } from '../../TickersDisplayBar';

import './styles.scss';

const TrendingMobile = () => {
  const { trending, items } = useMarqueeItems();

  return (
    <div className='trending__mobile'>
      <div className='trending__mobile__title'>
        <Image src={flash} size='m' />
      </div>
      <div className='trending__mobile__items'>
        {trending.map((item) => (
          <TrendingCoinMobile key={item.id} item={item} />
        ))}
        {items.map((item) => (
          <GainersPairMobile key={item.id} item={item} />
        ))}
      </div>
    </div>
  );
};

export default TrendingMobile;
